import meta from 'vue-meta'
import Antd from 'ant-design-vue'

import i18n from '../i18n'
import conf from '../conf'

import AppWithAntd from '../AppWithAntd.vue'

import antdx from '../components/common/antdx'
import valid from '../components/common/valid'

import '../components/common/tg/index.less'
import './registerServiceWorkerWithAntd'

export default {
  newInstance (Vue, router, store) {
    Vue.config.productionTip = false

    Vue.prototype.$conf = conf


    Vue.use(meta)
    Vue.use(Antd)
    Vue.use(valid)
    antdx.init(Vue, router, i18n)

    return new Vue({
      i18n,
      router,
      store,
      render: h => h(AppWithAntd)
    }).$mount('#app')
  }
}
